<template>
  <div id="qr-code-wrapper" class="ma-8">
    <qrcode-vue :value="qrCodeUrl" :size="size" level="L" />
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "QrCode",
  components: {
    QrcodeVue,
  },
  props: {
    qrCodeUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      size: 200,
    };
  },
};
</script>
